// Относительные URL типа "/uploads/dishes/xxx.webp" превращает в абсолютные
// с использованием VITE_API_URL — нужно для <img src>, так как axios baseURL
// задан только для axios-клиента, а не для тега <img>.
const baseUrl = import.meta.env.VITE_API_URL?.trim() || '';

export function asAbsoluteUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  return `${baseUrl}${url}`;
}
